// extracted by mini-css-extract-plugin
export default {"ErrorBoundary":"ErrorBoundary36lvKmnqg63J"};